import { ShortCardTimeReadout } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SkeletonThumbnail from '../../../components/TrackCard/Thumbnail/SkeletonThumbnail';
import ThumbnailOverlayed, { CardCompletedMessage } from '../../../components/TrackCard/Thumbnail/ThumbnailOverlayed';
import { CardMenuIcon } from '../../../features/cardMenu';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import { useShort, useShortStatus } from '../../shortContent';
import { jsx as _jsx } from "react/jsx-runtime";
export const CategoryLabel = styled.div.withConfig({
  displayName: "ShortThumbnailOverlayed__CategoryLabel",
  componentId: "sc-8wdh4h-0"
})(["color:", ";text-transform:capitalize;", ";"], theme.colors.OLAF, ({
  $isGhost
}) => $isGhost ? `opacity: .5` : '');
export const ShortThumbnailOverlayed = ({
  shortId,
  language,
  isGhost,
  disableGradient,
  centerContent,
  renderMenu = menu => menu,
  header
}) => {
  const {
    short
  } = useShort(shortId, language);
  const {
    status
  } = useShortStatus(shortId, language);
  const completed = status === 'COMPLETED';
  if (!short) {
    return /*#__PURE__*/_jsx(SkeletonThumbnail, {});
  }
  const {
    previewThumbnailRectangleUrl,
    subCategories
  } = short;
  const category = subCategories && subCategories.length && subCategories[0];
  return /*#__PURE__*/_jsx(ThumbnailOverlayed, {
    completed: completed,
    completedMessage: /*#__PURE__*/_jsx(CardCompletedMessage, {
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.shortContent.watched"
      })
    }),
    disableGradient: disableGradient,
    header: header || !!category && /*#__PURE__*/_jsx(CategoryLabel, {
      $isGhost: !!isGhost,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyCategories.${category}`
      })
    }),
    headerIcons: renderMenu( /*#__PURE__*/_jsx(CardMenuIcon, {
      language: language,
      shortId: shortId,
      use: "on-dark"
    })),
    isGhost: isGhost,
    previewThumbnailRectangleUrl: previewThumbnailRectangleUrl || undefined,
    thumbnailCenter: centerContent,
    thumbnailFooter: !completed && /*#__PURE__*/_jsx(ShortCardTimeReadout, {
      language: language,
      shortId: shortId
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'learningCenter.shortCard.label'
    })
  });
};
export default ShortThumbnailOverlayed;